import { ActivityGridController } from '../controller/ActivityGridController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';

export class ActivityGridWebComponent extends BaseWebComponentElement {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: ActivityGridController,
    });
  }
}
